import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

/**
 * In the top right corner of a container
 * Sets the containerFloat topology
 */
const ContainerFloat: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      sx={{
        alignItems: { xs: 'start', sm: 'center' },
        display: 'flex',
        gap: { xs: '0.5rem', md: '1rem' },
        flexDirection: { xs: 'column', sm: 'row' },
        width: '100%',
        justifyContent: { xs: 'space-between', md: 'end' },
      }}
    >
      {children}
    </Box>
  );
};

export default ContainerFloat;
